import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { useEffect, useId, useState } from 'react';
import AsyncContactsPriceBreakdownModal from '../../../../components/common/pricing/AsyncContactsPriceBreakdownModal'; // Ticket for migration: https://git.hubteam.com/HubSpot/pricing-pages-unified-ui/issues/14407

// Ticket for migration: https://git.hubteam.com/HubSpot/pricing-pages-unified-ui/issues/14408
import { trackModalInteraction } from '../../../../v2/utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IncludedContacts = ({
  additionalUnitSkuId,
  queryParamTerm,
  productLevel,
  includedWithParentProduct
}) => {
  const [priceBreakdownVisible, setPriceBreakdownVisible] = useState(false);
  useEffect(() => {
    if (priceBreakdownVisible) {
      trackModalInteraction({
        action: 'click to open',
        name: 'contact-picker-more-details-modal',
        trackingSource: 'merch-card',
        productLevel
      });
    }
  }, [priceBreakdownVisible, productLevel]);
  const marketingContactsTitleId = useId();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [priceBreakdownVisible && /*#__PURE__*/_jsx(AsyncContactsPriceBreakdownModal, {
      quantityPackSkuId: additionalUnitSkuId,
      handleModalClose: () => setPriceBreakdownVisible(false),
      queryParamTerm: queryParamTerm
    }), /*#__PURE__*/_jsx(View, {
      paddingBlockStart: "100",
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        alignItems: "start",
        gap: "200",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          id: marketingContactsTitleId,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            "data-test-id": "included-contacts",
            message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedContacts.includes",
            options: {
              includedAdditionalUnits: /*#__PURE__*/_jsx(FormattedNumber, {
                value: includedWithParentProduct
              }),
              link: /*#__PURE__*/_jsx(View, {
                display: "inline-block",
                as: "span",
                children: /*#__PURE__*/_jsx(Link, {
                  onClick: () => setPriceBreakdownVisible(true),
                  onMouseEnter: () => void AsyncContactsPriceBreakdownModal.preload(),
                  "data-selenium-id": "marketing-contacts-modal-open-button",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedContacts.marketingContacts"
                  })
                })
              })
            }
          })
        })
      })
    })]
  });
};